import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons';

const RegularizationSection = ({ regularisation, virementEffectueClass, classReste, virementEffectueAbs, resteArembourserAbs }) => {
  return (
    <>
      <tr className="accounting-section">
        <td className="label" style={{ backgroundColor: '#f9fafb', fontWeight: '600' }}>
          <FontAwesomeIcon icon={faHandHoldingUsd} /> RÉGULARISATION
        </td>
        <td className="value" style={{ backgroundColor: '#f9fafb' }}></td>
      </tr>
      <tr>
        <td className="label">Caution déposée</td>
        <td className="value"><strong>{regularisation?.caution || 0} €</strong></td>
      </tr>
      <tr>
        <td className="label">Retenue sur caution</td>
        <td className="value"><strong>{regularisation?.retenueCaution || 0} €</strong></td>
      </tr>
      <tr style={{ backgroundColor: '#f0f9ff' }}>
        <td className="label" style={{ fontWeight: '600' }}>Virements déjà effectués</td>
        <td className={`value ${virementEffectueClass}`}><strong>{virementEffectueAbs} €</strong></td>
      </tr>
      
      {/* Section Solde Final */}
      <tr className="final-balance-row" style={{ borderTop: '2px solid #4f46e5' }}>
        <td className="label" style={{ fontWeight: '600' }}>SOLDE FINAL</td>
        <td className={`value ${classReste}`}>
          <strong style={{ color: regularisation?.resteArembourser > 0 ? '#ef4444' : 'inherit' }}>
            {resteArembourserAbs} €
          </strong>
          <div style={{
            fontSize: '9px',
            marginTop: '3px',
            color: regularisation?.resteArembourser > 0 ? '#ef4444' : '#6b7280'
          }}>
            {regularisation?.resteArembourser > 0
              ? 'À recevoir du locataire'
              : 'À verser au locataire'}
          </div>
        </td>
      </tr>
    </>
  );
};

export default RegularizationSection;
